import { SuppliersApi, useAPIQuery } from "melco-shared-logic";

export const useGetSupplierProductsBySupplierId = (supplierId?: string) => {
  let { data } = useAPIQuery(
    SuppliersApi,
    ["manageSupplierProductsBySupplierId", supplierId],
    async (api) => {
      let response = await api.supplierProductsSearch({
        supplierId: supplierId,
      });
      return response;
    }
  );

  return {
    data: data?.list ?? [],
    total: data?.total ?? 0,
    warning_list: data?.warning_list ?? [],
  };

  // const [GetSupplierProductsBySupplierId] = useAPIAction(
  //     ControlCenterApi,
  //     async (api) => {
  //         let response = await api.manageSupplierProductsSearch({
  //             supplierId: !isEmpty(supplierId) ? supplierId : undefined
  //         })
  //         return {
  //             successMessages: [{ message: "" }],
  //             data: response
  //         }
  //     }, {
  //     translationPrefix: ''
  // })
  // return useCallback(async () => {
  //     let response = await GetSupplierProductsBySupplierId()
  //     debugger;
  //     return response
  // }, [GetSupplierProductsBySupplierId])
};
